"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var client_1 = require("@apollo/client");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var Button_1 = __importDefault(require("../../../../common/Button/Button"));
var TextArea_1 = __importDefault(require("../../../../common/TextInput/TextArea"));
var TextInput_1 = __importDefault(require("../../../../common/TextInput/TextInput"));
var general_1 = require("../../../../lib/general");
var icons_1 = __importDefault(require("../../../../theme/icons"));
var Mutation_1 = require("../../Graphql/Mutation");
var IsCorrectSelector_1 = __importDefault(require("../Selectors/IsCorrectSelector"));
// import QuestionSelector from "../Selectors/QuestionSelector";
var DiseaseQuestionAnswer = function (props) {
    var _a = (0, react_i18next_1.useTranslation)(), i18n = _a.i18n, t = _a.t;
    var getCurrentLang = i18n.language;
    var error = props.error, editableAnswers = props.editableAnswers;
    var _b = (0, react_1.useState)([
        {
            id: null,
            answer: JSON.stringify(props.languages),
            description: JSON.stringify(props.languages),
            is_correct: null,
            order_by: null,
            status: true,
        },
    ]), answers = _b[0], setAnswer = _b[1];
    var updateAnswerStautus = (0, client_1.useMutation)(Mutation_1.UPDATE_ANSWER_STATUS)[0];
    (0, react_1.useEffect)(function () {
        if (editableAnswers.length > 0) {
            setAnswer(editableAnswers);
        }
    }, [editableAnswers]);
    var addAnswer = function () {
        var values = __spreadArray([], answers, true);
        values.push({
            id: null,
            answer: JSON.stringify(props.languages),
            description: JSON.stringify(props.languages),
            is_correct: null,
            order_by: null,
            status: true,
        });
        setAnswer(values);
    };
    var removeAnswer = function (i) {
        var values = __spreadArray([], answers, true);
        var removedValue = values.splice(i, 1);
        setAnswer(values);
        if (Array.isArray(removedValue) && removedValue[0].id != null) {
            updateAnswerStautus({
                variables: {
                    id: removedValue[0].id,
                    status: false,
                },
            }).then(function () {
                props.deleteMessage("deleted_successfully");
            });
        }
        else {
            props.deleteMessage("deleted_successfully");
        }
    };
    var onHandleChange = function (i, value, type) {
        var values = __spreadArray([], answers, true);
        if (type === "answer") {
            var parsedValue = JSON.parse(values[i][type]);
            parsedValue[i18n.language] = value;
            values[i][type] = JSON.stringify(parsedValue);
        }
        else if (type === "description") {
            var parsedValue = JSON.parse(values[i][type]);
            parsedValue[i18n.language] = value;
            values[i][type] = JSON.stringify(parsedValue);
        }
        else if (type === "order_by") {
            values[i][type] = value;
        }
        else {
            values[i][type] = value.value;
        }
        setAnswer(values);
        props.handleMultipleAnswer(values);
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { style: {
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
            } },
            react_1.default.createElement("label", { className: "label", style: { marginLeft: "0.8rem" } }, (0, general_1.isJsonWithAvailableLang)("answer", getCurrentLang, t)),
            react_1.default.createElement(Button_1.default, { className: "modal-button", icon: react_1.default.createElement(icons_1.default, { name: "plus", className: "icon", height: 30, width: 30 }), onClick: function () { return addAnswer(); } })),
        react_1.default.createElement("p", null, error && error.field === "answer" && error.message),
        react_1.default.createElement(react_1.default.Fragment, null, answers.map(function (item, idx) {
            var findIndex = error &&
                error.field === "answers" &&
                error.message.length > 0 &&
                error.message.find(function (i) { return i.index === idx; });
            return (react_1.default.createElement("div", { key: idx, style: {
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                } },
                react_1.default.createElement("div", { className: "form-container", key: idx, style: {
                        boxShadow: "0px 0px 12px 2px #e4f1f5",
                        paddingRight: "7px",
                        borderRadius: "5px",
                        marginTop: "10px",
                        marginBottom: "15px",
                        borderColor: "rgb(228, 241, 245)",
                    } },
                    react_1.default.createElement("div", { style: {
                            display: "flex",
                            alignItems: "center",
                            flexWrap: "wrap",
                        } },
                        react_1.default.createElement(TextInput_1.default, { InputLabelStyle: {
                                flexDirection: "column",
                                justifyContent: "flex-start",
                                alignItems: "flex-start",
                            }, 
                            // error={error && error.field === "name" && error.message}
                            error: findIndex &&
                                findIndex.index === idx &&
                                findIndex.type === "name" &&
                                findIndex.message, label: t("name"), onChange: function (e) {
                                return onHandleChange(idx, e.target.value, "answer");
                            }, value: (0, general_1.isJsonWithAvailableLang)(item.answer, getCurrentLang.toLowerCase(), t) }),
                        react_1.default.createElement(IsCorrectSelector_1.default, { error: findIndex &&
                                findIndex.index === idx &&
                                findIndex.type === "isCorrect" &&
                                findIndex.message, InputLabelStyle: {
                                flexDirection: "column",
                                justifyContent: "flex-start",
                                alignItems: "flex-start",
                            }, label: (0, general_1.isJsonWithAvailableLang)("is_this_correct", getCurrentLang, t), value: item.is_correct, onChange: function (e) {
                                onHandleChange(idx, e, "is_correct");
                            } })),
                    react_1.default.createElement("div", { style: {
                            display: "flex",
                            alignItems: "flex-start",
                            flexWrap: "wrap",
                        } },
                        react_1.default.createElement(TextArea_1.default, { error: findIndex &&
                                findIndex.index === idx &&
                                findIndex.type === "description" &&
                                findIndex.message, label: t("description"), InputLabelStyle: {
                                flexDirection: "column",
                                justifyContent: "flex-start",
                                alignItems: "flex-start",
                            }, TextAreaStyle: { width: "45vw" }, onChange: function (e) {
                                return onHandleChange(idx, e.target.value, "description");
                            }, value: (0, general_1.isJsonWithAvailableLang)(item.description, getCurrentLang.toLowerCase(), t) }))),
                react_1.default.createElement(Button_1.default, { className: "modal-button", icon: react_1.default.createElement(icons_1.default, { name: "remove", className: "icon", height: 30, width: 30 }), onClick: function () { return removeAnswer(idx); } })));
        }))));
};
exports.default = DiseaseQuestionAnswer;
